export const ConnectionRequestEvents = {
    BuyerModalOpened: "connection_requests.modal.add_buyer.opened",
    BuyerModalClosed: "connection_requests.modal.add_buyer.closed",
    BuyerModalCreated: "connection_requests.modal.add_buyer.created",
    StatusUpdated: "connection_requests.status_updated",
};

export const ContactsEvents = {
    BuyerModalOpened: "contacts.modal.add_buyer.opened",
    BuyerModalClosed: "contacts.modal.add_buyer.closed",
    BuyerModalCreated: "contacts.modal.add_buyer.created",
    BuyerAddedToCompany: "contacts.modal.add_buyer_to_company",
    CompanyCreated: "contacts.company_created",
};

export const CompanyContactsEvents = {
    BuyerModalOpened: "companies.contacts.modal.add_buyer.opened",
    BuyerModalClosed: "companies.contacts.modal.add_buyer.closed",
    BuyerModalCreated: "companies.contacts.modal.add_buyer.created",
};
